import { useCallback, useEffect, useRef, useState } from 'react';
import { getApprovalQueue } from '../reports/api-decisions';
import type { ApprovalQueue } from '../reports/api-decisions';

export type QueueState =
  | { status: 'loading' }
  | { status: 'error' }
  | { status: 'forbidden' }
  | { status: 'ready'; queue: ApprovalQueue };

/** The caller's «Da approvare» queue (spec §1.4): what they may decide now, by level. */
export function useApprovalQueue() {
  const [state, setState] = useState<QueueState>({ status: 'loading' });
  const [reads, setReads] = useState(0);
  const generation = useRef(0);

  useEffect(() => {
    const mine = ++generation.current;
    setState({ status: 'loading' });
    void getApprovalQueue().then((outcome) => {
      if (mine !== generation.current) return;
      // A 403 is not a fault: the caller is not an approver (the page is reachable by its address).
      if (outcome.ok) setState({ status: 'ready', queue: outcome.value });
      else setState({ status: outcome.status === 403 ? 'forbidden' : 'error' });
    });
  }, [reads]);

  const reload = useCallback(() => setReads((count) => count + 1), []);
  return { state, reload } as const;
}
